import React from "react";
import { useUserContext } from "../../contexts/UserContext";
import { Grid } from "../../UI/Grid";

import { UserFreeTextQuestions } from "./UserFreeTextQuestions";
import { UserSelectQuestions } from "./UserSelectQuestions";
import { UserSliderQuestions } from "./UserSliderQuestions";

export const UserQuestions = () => {
  const { user } = useUserContext();

  const sliderQuestions = user?.userLifestyleQuestionsWithAnswers.questions.SLIDER;
  const selectQuestions = user?.userLifestyleQuestionsWithAnswers.questions.SELECT;
  const freeTextQuestions = user?.userLifestyleQuestionsWithAnswers.questions.FREE_TEXT;

  return (
    <Grid container py={3}>
      <Grid item xs={12}>
        <UserSliderQuestions questions={sliderQuestions} />
      </Grid>
      <Grid item xs={12}>
        <UserSelectQuestions questions={selectQuestions} />
      </Grid>
      <Grid item xs={12}>
        <UserFreeTextQuestions questions={freeTextQuestions} />
      </Grid>
    </Grid>
  );
};
